"use client";

import CopyButton from "@/components/copy-button";
import ScrambledText from "@/components/scrambled-text";

const INSTALL_COMMAND = "source <(curl -fsSL https://haiii.co/install.sh)";

export default function InstallCommand() {
    return (
        <div className="inline-flex w-fit items-center gap-3 rounded-md bg-gray-100 px-3 py-2 font-geist-mono text-base lg:text-2xl">
            <ScrambledText text={INSTALL_COMMAND} className="whitespace-nowrap" />
            <CopyButton textToCopy={INSTALL_COMMAND} className="cursor-pointer" />
        </div>
    );
}
